/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconVisa: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M360.736 679.296l51.84-321.696h82.912l-51.84 321.664h-82.88m383.52-313.76A204.864 204.864 0 0 0 670.08 352c-81.984 0-139.68 43.648-140.16 106.176-0.512 46.208 41.184 72 72.608 87.36 32.32 15.776 43.168 25.856 43.008 39.936-0.192 21.536-25.76 31.424-49.6 31.424-33.184 0-50.816-4.864-78.08-16.864l-10.656-5.12-11.584 72c19.328 8.96 55.136 16.736 92.352 17.152 87.072 0 143.68-43.136 144.32-109.888 0.32-36.64-21.76-64.448-69.6-87.392-28.992-14.912-46.752-24.8-46.56-39.904 0-13.376 15.04-27.68 47.488-27.68a145.376 145.376 0 0 1 62.048 12.352l7.424 3.68 11.232-69.76m110.4 199.744c6.848-18.464 32.992-89.92 32.992-89.92-0.48 0.864 6.816-18.624 11.008-30.656l5.6 27.744 19.2 92.832h-68.8z m102.24-207.296h-64.064c-19.872 0-34.752 5.696-43.456 26.656l-123.104 294.816h87.072s14.208-39.648 17.44-48.352l106.176 0.16c2.464 11.232 10.08 48.224 10.08 48.224H1024l-67.072-321.504zM291.2 357.856l-81.12 219.328-8.704-44.576C186.24 481.28 139.2 425.6 86.56 397.664l74.24 281.344 87.68-0.064 130.56-321.088H291.2"
        fill={getIconColor(color, 0, '#26337A')}
      />
      <path
        d="M134.72 357.664H1.12L0 364.32c104 26.624 172.8 90.976 201.376 168.32l-29.024-147.84c-5.024-20.384-19.584-26.432-37.6-27.136"
        fill={getIconColor(color, 1, '#EC982D')}
      />
    </svg>
  );
};

IconVisa.defaultProps = {
  size: 18,
};

export default IconVisa;
